(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdown(el) {
    var endTime = new Date(el.dataset.endTime).getTime();
    if (isNaN(endTime)) return;

    var daysEl = el.querySelector('[data-cd-days]');
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minsEl = el.querySelector('[data-cd-mins]');
    var secsEl = el.querySelector('[data-cd-secs]');
    var activeEl = el.querySelector('[data-cd-active]');
    var endedEl = el.querySelector('[data-cd-ended]');
    var timerId;

    function tick() {
      var diff = endTime - Date.now();

      if (diff <= 0) {
        if (activeEl) activeEl.hidden = true;
        if (endedEl) endedEl.hidden = false;
        if (timerId) clearInterval(timerId);
        return;
      }

      var totalSecs = Math.floor(diff / 1000);
      var days = Math.floor(totalSecs / 86400);
      var hours = Math.floor((totalSecs % 86400) / 3600);
      var mins = Math.floor((totalSecs % 3600) / 60);
      var secs = totalSecs % 60;

      if (daysEl) {
        daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
      } else if (hoursEl) {
        hoursEl.textContent = pad(hours + days * 24);
      }
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);

      if (totalSecs < 3600 && !el.classList.contains('is-urgent')) {
        el.classList.add('is-urgent');
      }
    }

    tick();
    timerId = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-omg-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
